import { apiClient } from './apiClient'
import type { Crew } from '../types/interchange'

export function getActiveCrews(): Promise<Crew[]> {
  return apiClient.get<Crew[]>('/api/crews/active')
}
